import gql from 'graphql-tag';

export default gql` 
query siteHeaderTranslations {
  application(name: DESKTOPBOOKINGPATH) {
    ... on DesktopBookingPath {
      translations(language: enUS) {
        loginSignUpForm {
          sessionInactivityTimeoutTitle
          sessionInactivityTimeoutMessage
          logOffButtonLabel
          stayLoggedInButtonLabel
        }
      }
    }
  }
}`
